import { Injectable, inject } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  TextOnlySnackBar,
} from '@angular/material/snack-bar';

import {
  HtmlSnackBarComponent,
  SnackBarMessagePart,
} from './html-snack-bar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  snackBar = inject(MatSnackBar);

  durationInSeconds = 5;

  errorBulkUpdateConfig: MatSnackBarConfig = {
    duration: this.durationInSeconds * 1000,
    panelClass: ['snack-bar'],
  };

  public openSnackBar(
    message: string,
    action: string = $localize`:@@SnackbarServiceDismissAction:Dismiss`,
    config: MatSnackBarConfig = this.errorBulkUpdateConfig,
  ): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackBar.open(message, action, config);
  }

  public openHtmlSnackBar(
    messageParts: SnackBarMessagePart[],
    action: string = $localize`:@@SnackbarServiceDismissAction:Dismiss`,
    config: MatSnackBarConfig = this.errorBulkUpdateConfig,
  ): MatSnackBarRef<HtmlSnackBarComponent> {
    return this.snackBar.openFromComponent(HtmlSnackBarComponent, {
      ...config,
      data: { messageParts, action },
    });
  }
}
